/**
 * What the card becomes when a scene could not get what it needs from the
 * network: what failed, and the two ways on.
 */

export const DEFAULT_FAILURE = "Something the tour needs didn't load.";
const TIMEOUT_FAILURE = "This is taking longer than it should.";

export function failureText(
  failures: Readonly<Record<string, string>>,
  failure: string | null,
): string {
  if (failure === "timeout") return TIMEOUT_FAILURE;
  return (failure && failures[failure]) || DEFAULT_FAILURE;
}

export function Fallback({
  text,
  onRetry,
  onExit,
}: {
  text: string;
  onRetry: () => void;
  /** Absent on the last step. */
  onExit?: () => void;
}) {
  return (
    <div
      data-tour-fallback=""
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "var(--co-onb-stack-md)",
      }}
    >
      <h1
        style={{
          margin: 0,
          fontSize: "var(--co-onb-fs-heading)",
          lineHeight: 1.1,
          letterSpacing: "-0.02em",
          fontWeight: 500,
          color: "var(--co-fg)",
        }}
      >
        <span>That didn&apos;t work.</span>
      </h1>
      <p
        style={{
          margin: 0,
          fontSize: "var(--co-onb-fs-lede)",
          lineHeight: 1.5,
          color: "var(--co-fg-muted)",
        }}
      >
        <span>{text}</span>
        <span> Your progress is saved.</span>
      </p>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: 14,
          marginTop: "var(--co-onb-stack-sm)",
        }}
      >
        {onExit && (
          <button
            type="button"
            className="_co_onb_quiet"
            data-tour-fallback-exit=""
            onClick={onExit}
          >
            <span>Exit tour</span>
          </button>
        )}
        <button
          type="button"
          className="_co_onb_finish"
          data-tour-retry=""
          data-tour-primary=""
          onClick={onRetry}
          style={{
            minHeight: 38,
            paddingLeft: 18,
            paddingRight: 18,
            fontSize: "var(--co-onb-fs-cta)",
          }}
        >
          <span>Try again</span>
        </button>
      </div>
    </div>
  );
}
